<section class="whats-new-panel">
  <header class="whats-new-header">
    <div>
      <span class="whats-new-eyebrow">What's New</span>
      <h2>Release notes</h2>
    </div>
    <button type="button" class="whats-new-close" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="whats-new-body">
    <article class="release-card" *ngFor="let release of releases; let first = first">
      <div class="release-card-head">
        <span class="release-version" [class.is-current]="release.version === currentVersion">
          v{{ release.version }}
        </span>
        <span class="release-codename">{{ release.codename }}</span>
        <span class="release-date">{{ release.date }}</span>
        <span class="release-latest-badge" *ngIf="first">Latest</span>
      </div>

      <ul class="release-change-list">
        <li
          class="release-change"
          *ngFor="let change of release.changes"
          [class.change-added]="change.type === 'added'"
          [class.change-improved]="change.type === 'improved'"
          [class.change-fixed]="change.type === 'fixed'"
        >
          <mat-icon class="change-icon">{{ changeTypeMeta[change.type].icon }}</mat-icon>
          <span class="change-text">
            {{ change.text }}
            <button
              type="button"
              class="change-guide-link"
              *ngIf="change.guideLink"
              (click)="onGuideLinkClick(change.guideLink)"
            >
              How to use this →
            </button>
          </span>
        </li>
      </ul>
    </article>
  </div>
</section>
